import request from '../../request'
import {themes} from '../../endpoints'

export default class themesApi {
  static async getCustomerThemes(schoolId, matId) {
    return request({
      url: themes.getCustomerThemes(schoolId, matId),
      method: 'GET',
    })
  }

  static async getSurveyThemes(id, schoolId, matId) {
    return request({
      url: themes.getSurveyThemes(id, schoolId, matId),
      method: 'GET',
    })
  }
  static async updateSurveyThemes(newThemes) {
    return request({
      url: themes.updateSurveyThemes(),
      method: 'POST',
      data: newThemes,
    })
  }
}
